































































































import { numberHigherRule } from "@/lib/rules/numberHigherRule";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CustomFieldBoolean from "../report/CustomFieldBoolean.vue";
import { IInsuranceContractRate, InsuranceContractRate } from "@/models/insurance-contract-rate.entity";

@Component({
  components: {
    CustomFieldBoolean
  }
})
export default class InsuranceContractForm extends Vue {
  @Prop({ required: true }) value!: IInsuranceContractRate;
  @Prop({ default: false }) isEditing!: boolean;

  localDetails: IInsuranceContractRate = new InsuranceContractRate({});

  @Watch("value", { immediate: true, deep: true })
  onDetailsChange(val: IInsuranceContractRate) {
    this.localDetails = val;
  }
  @Watch("localDetails", { deep: true })
  onLocalDetailsChange() {
    this.$emit("update:value", this.localDetails);
  }

  onFieldChanged(labelKey: string) {
    if (!this.isEditing) return;
    this.$emit("field-changed", labelKey);
  }

  get greaterThanZeroRule() {
    return [numberHigherRule(0)];
  }
}
